import React from 'react'
import { Button } from './styledComponents'
import html2pdf from 'html2pdf.js'

const DownloadButton = () => {
  const handleDownload = () => {
    const element = document.getElementById('letter-content')

    const opt = {
      margin: 0,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff', // white background
      },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: 'portrait',
        backgroundColor: '#ffffff',
      },
      pagebreak: { mode: ['avoid-all'] },
    }

    html2pdf().set(opt).from(element).save()
  }

  return <Button onClick={handleDownload}>Download PDF</Button>
}

export default DownloadButton
